/*
saikrishna 10/04/2022 2701306337 Fixed client maintenance and role management bugs JIra(229,232,33,34,49,56,58,393,94,95).
sohel 10/06/2022 2701306337 Record Format ->File Type and Record Format System Notes Payload Changes
saikrishna 11/03/2022 2701306337 changed the paginationOptions
*/

import React, {createRef, useState, useEffect} from 'react';
// import MaterialTable from "material-table";
import {TablePagination, Button} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import AddUserDefinedNotes from '../../../../components/AddUserDefinedNotes';
import DialogBox from '../../../../components/DialogBox';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import {
  AddNotes as addNotes,
  resetPostStatus,
  NotesResetToast as notesResetToast,
} from '../../../../redux/reducers/RecordFormat/addANote';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';
export default function RecordFormatSystemNotes({recordFormatCode, setRecordFormatCode}) {
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Type',
      field: 'noteType',
    },
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Record Format Code',
      field: 'recordFormatcode',
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
  ];
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);

  const {addNoteStatus, isLoading, errorMsg, successMsg} = useSelector(
    ({recordAddNotes}) => recordAddNotes,
  );
  let transcription = '';
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const recordFormatAccess = roleData?.window?.['Record Format']?.['RF'];
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  useEffect(() => {
    if (addNoteStatus === 200) {
      handleDialogClose();
      tableRef.current.onQueryChange();
      dispatch(resetPostStatus());
      setTimeout(() => {
        dispatch(notesResetToast());
      }, 3000);
    }
  }, [addNoteStatus]);

  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        addNotes({
          noteText: data,
          code: recordFormatCode ? recordFormatCode : '',
        }),
      );
    }
  };

  return (
    <div className="custom-table">
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            isLoading={isLoading}
            reportMasterDisableAdd={recordFormatAccess}
          />
        )}
      </DialogBox>
      <GuiTable
        title=""
        columns={columns}
        icons={tableIcons}
        tableRef={tableRef}
        data={(query) =>
          new Promise((resolve) => {
            const url = `rules/find/all/recordformatnotes`;
            const bodyObj = {
              code: recordFormatCode,
              limit: rows,
              orderBy: '',
              orderDirection: '',
              search: '',
              page:
                arrayLast && query.page >= 1 ?
                  query.page :
                  arrayLast ?
                    (query.page <= 1 && query.page + 1) || query.page - 1 :
                    query.page + 1,
            };
            if (!recordFormatCode) {
              resolve({
                data: [],
                page: 0,
                totalCount: 5,
              });
            } else {
              httpPaginationPost(url, bodyObj)
                .then((response) => {
                  if (response?.status === 200) {
                    const data = response.data.response.resultObjects;
                    resolve({
                      data: data.length > 0 ? data : [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    setArrayLast(response.data.response.resultObjects.length === 1);
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                .catch((response) => {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                });
            }
          })
        }
        options={{
          search: false,
          pageSize: rows,
          showSelectAllCheckbox: false,
          emptyRowsWhenPaging: false,
          pageSizeOptions: tablePageRows,
          headerStyle: {
            fontWeight: 'bold',
          },
        }}
        actions={[
          {
            icon: () => (
              <div>
                <Button variant="contained" className="themeing-buttons">
                  <AddIcon /> Add
                </Button>
              </div>
            ),
            isFreeAction: true,
            onClick: () => handleSelectedNotesOption(),
          },
        ]}
        components={{
          Pagination: (props) => (
            <TablePagination
              {...props}
              rowsPerPageOptions={tablePageRows}
              onChangeRowsPerPage={(event) => {
                props.onChangeRowsPerPage(event);
                setRows(event.target.value);
              }}
            />
          ),
        }}
      />
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}
